export default __webpack_public_path__ + "static/media/without-sectors.3e0f269f.svg";